export enum ContactArea {
  PARENT_CONTACT = 'Elternansprechpartner',
  PSYCHOSOCIAL = 'Psychosoziale Versorgung',
  STATION = 'Station',
  NURSING = 'Pflege',
  CUSTOM = 'Eigene Bezeichnung'
}
